"use strict";

var _createForOfIteratorHelper = require("/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _taggedTemplateLiteral = require("/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["", " === ", ""]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["typeof ", " == \"string\""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["", "", ""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["{error: ", ", tag: ", ", tagValue: ", "}"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var codegen_1 = require("../../compile/codegen");

var types_1 = require("../discriminator/types");

var error = {
  message: function message(_ref) {
    var _ref$params = _ref.params,
        discrError = _ref$params.discrError,
        tagName = _ref$params.tagName;
    return discrError === types_1.DiscrError.Tag ? "tag \"".concat(tagName, "\" must be string") : "value of tag \"".concat(tagName, "\" must be in oneOf");
  },
  params: function params(_ref2) {
    var _ref2$params = _ref2.params,
        discrError = _ref2$params.discrError,
        tag = _ref2$params.tag,
        tagName = _ref2$params.tagName;
    return codegen_1._(_templateObject(), discrError, tagName, tag);
  }
};
var def = {
  keyword: "discriminator",
  type: "object",
  schemaType: "object",
  error: error,
  code: function code(cxt) {
    var gen = cxt.gen,
        data = cxt.data,
        schema = cxt.schema,
        parentSchema = cxt.parentSchema,
        it = cxt.it;
    var oneOf = parentSchema.oneOf;

    if (!it.opts.discriminator) {
      throw new Error("discriminator: requires discriminator option");
    }

    var tagName = schema.propertyName;
    if (typeof tagName != "string") throw new Error("discriminator: requires propertyName");
    if (schema.mapping) throw new Error("discriminator: mapping is not supported");
    if (!oneOf) throw new Error("discriminator: requires oneOf keyword");
    var valid = gen.let("valid", false);
    var tag = gen.const("tag", codegen_1._(_templateObject2(), data, codegen_1.getProperty(tagName)));
    gen.if(codegen_1._(_templateObject3(), tag), function () {
      return validateMapping();
    }, function () {
      return cxt.error(false, {
        discrError: types_1.DiscrError.Tag,
        tag: tag,
        tagName: tagName
      });
    });
    cxt.ok(valid);

    function validateMapping() {
      var mapping = getMapping();
      gen.if(false);

      for (var tagValue in mapping) {
        gen.elseIf(codegen_1._(_templateObject4(), tag, tagValue));
        gen.assign(valid, applyTagSchema(mapping[tagValue]));
      }

      gen.else();
      cxt.error(false, {
        discrError: types_1.DiscrError.Mapping,
        tag: tag,
        tagName: tagName
      });
      gen.endIf();
    }

    function applyTagSchema(schemaProp) {
      var _valid = gen.name("valid");

      var schCxt = cxt.subschema({
        keyword: "oneOf",
        schemaProp: schemaProp
      }, _valid);
      cxt.mergeEvaluated(schCxt, codegen_1.Name);
      return _valid;
    }

    function getMapping() {
      var _a;

      var oneOfMapping = {};
      var topRequired = hasRequired(parentSchema);
      var tagRequired = true;

      for (var i = 0; i < oneOf.length; i++) {
        var sch = oneOf[i];
        var propSch = (_a = sch.properties) === null || _a === void 0 ? void 0 : _a[tagName];

        if (typeof propSch != "object") {
          throw new Error("discriminator: oneOf schemas must have \"properties/".concat(tagName, "\""));
        }

        tagRequired = tagRequired && (topRequired || hasRequired(sch));
        addMappings(propSch, i);
      }

      if (!tagRequired) throw new Error("discriminator: \"".concat(tagName, "\" must be required"));
      return oneOfMapping;

      function hasRequired(_ref3) {
        var required = _ref3.required;
        return Array.isArray(required) && required.includes(tagName);
      }

      function addMappings(sch, i) {
        if (sch.const) {
          addMapping(sch.const, i);
        } else if (sch.enum) {
          var _iterator = _createForOfIteratorHelper(sch.enum),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var tagValue = _step.value;
              addMapping(tagValue, i);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else {
          throw new Error("discriminator: \"properties/".concat(tagName, "\" must have \"const\" or \"enum\""));
        }
      }

      function addMapping(tagValue, i) {
        if (typeof tagValue != "string" || tagValue in oneOfMapping) {
          throw new Error("discriminator: \"".concat(tagName, "\" values must be unique strings"));
        }

        oneOfMapping[tagValue] = i;
      }
    }
  }
};
exports.default = def;